/**
 * Created by prog2 on 25/10/2018.
 */

export default {
    message: {
        title: 'VALENCIA CATHEDRAL',
        preferVisitRead: 'Prefereixo llegir',
        preferVisitListten: 'Prefereixo escoltar ',
        downloadAudio: '(Downloading)',
        download:'Downloading',
        errorDownload: '',
        cancelDownload: '',
        initDownload: 'Please wait while audio tour is downloading',
        endDownload: 'Your tour has been downloaded. Enjoy your visit!',
        retry: 'Reintentar',
        noConnection: '',
        titleMap: '',
        map: 'Plano1.png',
        menuItems: [
            {
                idImages: 1,
                title: 'Welcome',
                author: 'Thank you for using headphones',
                description: '',
                // audio: require('./../../assets/audio/ESP/1.mp3')
                audio: '1.mp3'
            },
            {
                idImages: 2,
                title: 'Chapel of Saint Sebastian',
                author: 'Foot of the Nave',
                description: '',
                audio: '2.mp3'

            },
            {
                idImages: 3,
                title: 'Chapel of Saint Peter the Apostle',
                author: 'Right-side Aisle',
                description: '',
                audio: '3.mp3'

            },
            {
                idImages: 4,
                title: 'Chapel of Saint Francis Borgia',
                author: 'Right-side Aisle',
                description: '',
                audio: '4.mp3'

            },
            {
                idImages: 5,
                title: 'The Oblique Window',
                author: '',
                description: '.',
                audio: '5.mp3'

            },
            {
                idImages: 6,
                title: 'Main Altar',
                author: 'Main Chapel',
                description: '',
                audio: '6.mp3'

            },
            {
                idImages: 7,
                title: 'Musician Angels',
                author: 'Main Chapel',
                description: '',
                audio: '7.mp3'

            },
            {
                idImages: 8,
                title: 'Lantern Tower',
                author: 'Crossing',
                description: '',
                audio: '8.mp3'

            },
            {
                idImages: 9,
                title: 'Portal of the Alms',
                author: 'Right Arm of the Transept',
                description: '',
                audio: '9.mp3'

            },
            {
                idImages: 10,
                title: 'Ambulatory + Organ',
                author: 'Ambulatory',
                description: '',
                audio: '10.mp3'

            },
            {
                idImages: 11,
                title: 'Resurrection',
                author: 'Ambulatory Chapels',
                description: '',
                audio: '11.mp3'

            },
            {
                idImages: 12,
                title: 'Christ of Good Death',
                author: 'Ambulatory Chapels',
                description: '',
                audio: '12.mp3'

            },
            {
                idImages: 13,
                title: 'Madonna of the Chair + St. James',
                author: 'Ambulatory Chapels',
                description: '',
                audio: '13.mp3'

            },
            {
                idImages: 14,
                title: 'Saint Denis and Saint Margaret',
                author: 'Ambulatory Chapels',
                description: '',
                audio: '14.mp3'

            },
            {
                idImages: 15,
                title: 'Portal of the Apostles',
                author: 'Left Arm of the Transept',
                description: '',
                audio: '15.mp3'

            },
            {
                idImages: 16,
                title: 'Directions to continue',
                author: 'Left-side Aisle',
                description: '',
                audio: '16.mp3'

            },
            {
                idImages: 17,
                title: 'Monstrance',
                author: 'Museum: Ground Floor',
                description: '',
                audio: '17.mp3'

            },
            {
                idImages: 18,
                title: 'Impenitent Thief + Adoration',
                author: 'Museum: Ground Floor',
                description: '',
                audio: '18.mp3'

            },
            {
                idImages: 19,
                title: 'Models',
                author: 'Museum: Second Floor',
                description: '',
                audio: '19.mp3'

            },
            {
                idImages: 20,
                title: 'Apostles',
                author: 'Museum: Second Floor',
                description: '',
                audio: '20.mp3'

            },
            {
                idImages: 21,
                title: 'Doubt of St. Thomas + Transit',
                author: 'Museum: Second Floor',
                description: '',
                audio: '21.mp3'

            },
            {
                idImages: 22,
                title: 'Reliquary',
                author: 'Museum: Second Floor',
                description: '',
                audio: '22.mp3'

            },
            {
                idImages: 23,
                title: 'Jesus Insulted by the Soldiers',
                author: 'Museum: Second Floor',
                description: '',
                audio: '23.mp3'

            },
            {
                idImages: 24,
                title: 'Corridor + Baroque Art',
                author: 'Museum: Second Floor',
                description: '',
                audio: '24.mp3'

            },
            {
                idImages: 25,
                title: 'Archaeological Excavations',
                author: 'Museum: Underground ',
                description: '',
                audio: '25.mp3'

            },
            {
                idImages: 26,
                title: 'Choirbooks + The Last Supper',
                author: 'Museum: Ground Floor',
                description: '',
                audio: '26.mp3'

            },
            {
                idImages: 27,
                title: 'The Holy Chalice',
                author: 'Chapel of the Holy Chalice',
                description: '',
                audio: '27.mp3'

            },
            {
                idImages: 28,
                title: 'Chapel of the Holy Chalice',
                author: 'Chapel of the Holy Chalice',
                description: '',
                audio: '28.mp3'

            },
            {
                idImages: 29,
                title: 'The Micalet',
                author: 'Foot of the Nave',
                description: '',
                audio: '29.mp3'

            },
            {
                idImages: 30,
                title: 'Credits',
                isCredits:true,
                author: '',
                description: 'Trama Media for Valencia Cathedral.<br><br>© Valencia Cathedral.<br><br>All rights reserved.<br><br>',
                audio: '',
                idCreditImage: 30,
            },


        ]

    }
};



// WEBPACK FOOTER //
// ./src/data/i18n/english.js